import { UserAvatar } from 'Components/shared/UserAvatar';
import { MobXProviderContext, observer } from 'mobx-react';
import React, { useContext } from 'react';
import type { RootStoreProps } from 'Stores/RootStore.types';
import { ContactAvatarProps } from './index.types';

/**
 * Avatar with live presence dot.
 */
const TransferContactAvatarBase = ({ contact }: ContactAvatarProps): React.ReactElement => {
  const rootStore = useContext(MobXProviderContext) as RootStoreProps;
  const sourceId = contact.sourceId;

  const presence =
    contact.contactType === 'directory' && sourceId
      ? rootStore?.ui?.selectPersonPresenceStatus(sourceId)
      : null;

  return (
    <UserAvatar
      name={contact.displayName}
      image={contact.avatar}
      presence={presence ?? undefined}
      size={32}
      fontSize={11}
      aria-hidden="true"
    />
  );
};

TransferContactAvatarBase.displayName = 'TransferContactAvatar';

export const TransferContactAvatar = observer(TransferContactAvatarBase);
